<template>
  <div v-if="value">
    <TipsExternalId v-if="showTips && fieldExists('externalId')"/>

    <!-- Type if new -->
    <div class="group" v-if="isNew && fieldExists('type')">
      <label>{{ $t('type') }}</label>
      <select v-model="value.type">
        <option value="item">{{ $t('item_type.item') }}</option>
        <!--<option value="variant">{{ $t('item_type.variant') }}</option>--><!-- NOT SUPPORTED: NO TIME -->
        <option value="modifier">{{ $t('item_type.modifier') }}</option>
        <option value="combo">{{ $t('item_type.combo') }}</option>
        <option value="supplement">{{ $t('item_type.supplement') }}</option>
      </select>
    </div>

    <!-- ExternalID-->
    <div class="group" v-if="fieldExists('externalId')">
      <label>{{$t('external_id')}}</label>
      <ExternalIDInput v-model="value.externalId" :inventory="inventoryId" :sync-item="value" :sync-silent="true"/>
    </div>

    <!-- Name -->
    <div class="group" v-if="fieldExists('name')" v-for="(_,l) of value.name" :key="`pf_name_${l}`">
      <label>{{ $t(`translation.${l}`) }}</label>
      <input type="text" v-model="value.name[l]">
    </div>

    <!-- Prices -->
    <div class="group" v-if="fieldExists('priceSchemes')" v-for="(s, i) of value.priceSchemes" :key="`pf_scheme_${i}`">
      <label>{{ $t(`scheme_methods.${s.method}`) }}</label>
      <input
          type="number" step="0.01" placeholder="00.00"
          v-model.number="value.priceSchemes[i].unitPrice"
      >
    </div>

    <!-- Note -->
    <div class="group" v-if="fieldExists('note')">
      <label>{{$t('note')}} ({{value.note ? value.note.length : 0}}/16)</label>
      <input type="text" v-model="value.note" :maxlength="16">
    </div>
  </div>
</template>

<script>
import ExternalIDInput from "@/components/inventory/ExternalIDInput.vue";
import TipsExternalId from "@/components/tips/TipsExternalId.vue";

export default {
  name: "ItemPowerForm",

  components: { ExternalIDInput, TipsExternalId },

  props: {
    value: {
      type: Object,
      required: true
    },
    inventoryId: {
      type: Number,
      required: true
    },
    fillDataFromExternalItem: {
      type: Boolean,
      default: true
    },
    showTips: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    isNew() {
      let id = this.value.id;
      return !id || (typeof id === 'string' && id.includes('tmp'))
    }
  },

  methods: {
    fieldExists(field) {
      return this.value[field] !== undefined
    }
  }
}
</script>

<style lang="scss" scoped>

</style>